<template>
  <b-card class="bg-white rounded-xl px-4">
    <div class="flex justify-between items-center">
      <div>
        <h2 class="text-2xl font-semibold">About-Us</h2>
      </div>

      <base-button
        outline
        class="px-6 py-1 mx-1"
        type="primary"
        @click="handleAdd"
      >
        <span class="btn-inner--text flex justify-between items-center"
          ><feather-icon icon="PlusIcon" class="cust-HW"></feather-icon> Add
        </span>
      </base-button>
    </div>
    <MainTable />
  </b-card>
</template>

<script>
import MainTable from "./components/mainTable.vue";
export default {
  components: {
    MainTable,
  },
  methods: {
    handleAdd() {
      this.$router.push({ name: "add-aboutus-main" });
    },
  },
};
</script>
<style></style>
